import { useState } from 'react';
import config from 'config/config';
import Icon from 'src/components/icon';

const PROGRAM_URL = `${config.cdn.navigator}lower-your-cholesterol/`;

const getMenu = () => (
  <section className="navigator__contents">
    <div className="navigator__contents-header">Contents</div>
    <ul className="navigator__contents__list">
      <li>
        <div className="navigator__contents__number">1.</div>
        <div className="navigator__contents__content-text">
          <a href="#1">Medication or lifestyle changes?</a>
        </div>
      </li>
      <li>
        <div className="navigator__contents__number">2.</div>
        <div className="navigator__contents__content-text">
          <a href="#2">How important are lifestyle changes?</a>
        </div>
      </li>
      <li>
        <div className="navigator__contents__number">3.</div>
        <div className="navigator__contents__content-text">
          <a href="#3">Do I need statins?</a>
        </div>
      </li>
    </ul>
  </section>
);

const getPage = () => (
  <div className="navigator">
    <section className="navigator__content">
      <h1 className="navigator__title">{'Week 3: Medication and lifestyle'}</h1>
      <p>
        {`Not everybody with high cholesterol is prescribed medication. But if you are, it's important to understand what
        your medication is and why you're taking it. Whether you have medication or not, you should still make lifestyle
        changes to lower your cholesterol to protect your health. Lifestyle changes can stop your high cholesterol from
        getting worse, and even help them reach a healthier level.`}
      </p>
      <div className="visible-xs">{getMenu()}</div>

      <h2>Medication or lifestyle changes?</h2>
      <p>
        {`When you're diagnosed with high cholesterol, your doctor or nurse might recommend that you try to lower it
        through lifestyle changes first, or they may recommend medication straight away. This is decided on a
        case-by-case basis.`}
      </p>
      <p>Your doctor will let you know if you should be taking medication for your high cholesterol.</p>
      <img alt="High and low risk individuals with high cholesterol" className="navigator__image-full" src={`${PROGRAM_URL}W03B01.jpg`} />
      <p />

      <h2>How important are lifestyle changes?</h2>
      <p>
        {`Whether you've been prescribed medication or not, it's very important that you make the changes you need to
        lower your cholesterol. This is because having a healthier lifestyle will still help to lower your cholesterol,
        as well as your chances of developing other risk factors like high blood pressure or Type 2 diabetes.`}
      </p>
      <p>{`If you haven't been prescribed medication, making changes now can help prevent you reaching the point.`}</p>
      <p>
        {`It's not a short-term fix - it's a lifelong commitment to looking after your health. Even when your cholesterol
        reaches a healthy level, you should maintain your lifestyle changes and not return to old habits.`}
      </p>
      <div className="navigator__video-container">
        <iframe
          allow="autoplay; encrypted-media; fullscreen"
          src="https://www.youtube.com/embed/BUPIOpoXM5Q"
        />
      </div>

      <h2>Do I need statins?</h2>
      <p>
        {`The most commonly prescribed medication for high cholesterol are statins. You'll be prescribed these if you're
        diagnosed with a high risk of heart and circulatory diseases.`}
      </p>
      <p>
        {`Statins lower the level of cholesterol in your blood. That's why it's always important to take the statins
        you've been prescribed, to help your cholesterol reach a healthy level.`}
      </p>
      <p>
        {`We'll revisit the subject of statins next week, answering your common questions and explaining more about
        how they work.`}
      </p>
    </section>
  </div>
);

function Footer() {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;
  return (
    <div className="navigator__footer">
      <img alt="Woman with headset" className="navigator__footer__image" src={`${PROGRAM_URL}cta-helpline.png`} />
      <div className="navigator__footer__inner">
        <div className="navigator__footer__title">Call our Heart Helpline</div>
        <div className="navigator__footer__description">
          Our Heart Helpline has Cardiac Nurses available to answer your questions. Call us on 0300 330 3311 or email{' '}
          <a
            className="navigator__footer__link"
            href="mailto:hearthelpline@bhf.org.uk"
          >
            hearthelpline@bhf.org.uk
          </a>
        </div>
        <div className="navigator__footer__close" onClick={() => setVisible(false)}>
          <Icon icon="cross" />
        </div>
      </div>
    </div>
  );
}

const obj = {
  getPage,
  getMenu,
  Footer,
  getSeoTitle: 'Lower your cholesterol | HealthUnlocked',
};

export default obj;
